// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"ce56e737","59":"c7a45ec2","210":"d2acffdc","224":"75696137","243":"04728bbb","270":"016aae35","536":"e9fc93d6","632":"13ae96d9","674":"b0ad8ac3","810":"2f4e0602","953":"42fa83e5","989":"37a12738"}[chunkId] + ".chunk.js";
};